import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_ConsentofRelease = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_ConsentofRelease' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>AUTHORIZATION FOR RELEASE AND/OR REQUEST FOR PHI (Public Health Information)</h3></p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>To</span>
                            <input type='text' id='txtOrgnization' name='txtOrgnization' className='add-only' />
                        </td>

                        <td className='w-250'><span className='eleHeader'>Date</span>
                            <input type='date' id='txtCurrentDate' name='txtCurrentDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    This signed consent authorizes the above named &nbsp;
                    <input type='text' id='txtAuthorizeName' name='txtAuthorizeName' className='add-only w-350 custom-add-only' /> &nbsp;
                    and Northwest Behavioral Health
                    Services, Inc. to share in verbal or written communication regarding health records information of the individual to whom it
                    pertains. The state of Florida regulates the release of information relating psychiatric, psychological, medical diagnoses, and
                    substance/alcohol use and HIV/AIDS. The State of Florida regulations prohibit further disclosure of mental health, alcohol use
                    and HIV/AIDS related information unless further disclosure of this information is expressly permitted by written consent of
                    the individual or the authorized legal representative to whom it pertains. All information released through verbal, written or
                    electronic communication will be held confidential in accordance with the Florida Statutes and Health Insurance Portability
                    and Accountability Act (HIPAA).
                </p>


                <p className='w-750'>Release of the following information &nbsp;
                    <input type='checkbox' id='cbFrom' name='cbFrom' className='add-only' value='From' />from/ &nbsp;
                    <input type='checkbox' id='cbTo' name='cbTo' className='add-only' value='To' />to &nbsp;
                    <input type='text' id='txtFrom' name='txtFrom' className='add-only w-250 custom-add-only' />&nbsp;/&nbsp;
                    <input type='text' id='txtTo' name='txtTo' className='add-only w-250 custom-add-only' />&nbsp;
                    is being requested.</p>

                <p className='w-750'><span className='eleHeader'>RECORDS TO BE RELEASED</span></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='TreatmentServicePlan' />Treatment/Service Plan</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProgressReports' name='cbProgressReports' className='add-only' value='ProgressReports' />Progress Reports</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMedicalRecords' name='cbMedicalRecords' className='add-only' value='MedicalRecords' />Medical Records</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationReports' name='cbEducationReports' className='add-only' value='EducationReports' />Education Reports</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDischargeSummaries' name='cbDischargeSummaries' className='add-only' value='DischargeSummaries' />Discharge Summaries</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPsychosocialPsychiatric' name='cbPsychosocialPsychiatric' className='add-only' value='PsychosocialPsychiatricEval' />Psychosocial/Psychiatric Eval</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDevelopmentHistory' name='cbDevelopmentHistory' className='add-only' value='EducationReports' />Social/Development History</td>
                        <td className='w-250'><input type='checkbox' id='cbVerbalCommunication' name='cbVerbalCommunication' className='add-only' value='DischargeSummaries' />Verbal Communication</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' />Other (Specify):
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Purpose:</span>
                    <textarea id='txtPurpose' name='txtPurpose' className='add-only' >
                    </textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Restrictions (if any):</span>
                    <textarea id='txtRestrictions' name='txtRestrictions' className='add-only' >
                    </textarea>
                </p>

                <p className='w-750'>
                    This release is protected under State and Federal Confidentiality Regulations Title 42 (CFR) (Part 2, and FS 90.503) and all
                    requirements and applicable provisions of the Health Insurance Portability and Accountability Act (HIPAA).<br />
                    <b>I understand this authorization will remain in effect for a period of one year (commencing on the date this form is signed) and
                        I may revoke this consent at any time. Revocation does not pertain to prior disclosures.</b>
                </p>


                <p className='w-750'>Revocation: I hereby revoke my permission to disclose information effective &nbsp;
                    <input type='text' id='txtDiscloseInformation_1' name='txtDiscloseInformation_1' className='add-only w-250 custom-add-only' />&nbsp;, 20
                    <input type='text' id='txtDiscloseInformation_2' name='txtDiscloseInformation_2' className='add-only w-250 custom-add-only' />&nbsp;. I understand this does not affect information released prior to this date.
                </p>

                <p className='w-750'><span className='eleHeader'>The one thing that is most important to me and worth living for is:</span>
                <textarea id='txtThingWorthLiving' name='txtThingWorthLiving' className='add-only' ></textarea>
                </p>

            </div>
        </form>

    )
}

